import React, {useMemo} from 'react';
import moment from "moment";
import {FormattedMessage} from "react-intl";
import {Typography} from "@mui/material";
import {useGetSoccerPlayerGamesStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";
import {getTeamShortName} from "../../../utils/SportUtils";
import GlobalConst from "../../../constants/GlobalConst";
import SOCCERSeasonStats from "./SOCCERSeasonStats";
import {getCurrentSeasonYearsBySportAndSeason} from "../../../constants/SportsConst";

import './SOCCERGamesStats.style.scss';
import "../PlayerGamesStats.style.scss";
const SOCCERGamesStats = ({contest}) => {

    const player = contest.player;
    const seasonYears = getCurrentSeasonYearsBySportAndSeason(3)

    const queryArgs = useMemo(() => ({
        playerId: player.PlayerId,
        from: moment().add(-1, 'weeks').toDate().getTime(),
        to: moment().add(1, 'days').endOf('day').toDate().getTime(),
        teamId: player.TeamId
    }), [player.PlayerId, player.TeamId]);

    const {data: gameStats, isLoading} = useGetSoccerPlayerGamesStatsByPlayerIdQuery(queryArgs);

    if (!gameStats)
        return <div className={"NoStats"}>No Stats Available</div>

    return <>
        {GlobalConst.FEATURES.SHOW_PLAYER_SEASON_STATS.SOCCER &&
            <SOCCERSeasonStats playerId={player.PlayerId}
                               seasonYears={seasonYears}/>}
        <div className="SOCCERgameLogSection">
            <Typography variant="h6" className="gameLogTitle">
                {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.gameLog"}/>
            </Typography>
            <div className="SoccerGamesStatsLog">
                <React.Fragment>
                    <div className="GameStats">
                        <div className="tableContainer">
                            <table className={"gameLogTable"}>
                                <thead>
                                <tr>{
                                    <React.Fragment>
                                        <th>Date vs Opp</th>
                                        <th className={ contest.StatsKey === "Goals" || contest.StatsKey === "GoalsAndAssists" ? "highlight gold-gradient-text" : ""}>G</th>
                                        <th className={ contest.StatsKey === "Assists" || contest.StatsKey === "GoalsAndAssists" ? "highlight gold-gradient-text" : ""}>A</th>
                                        <th className={ contest.StatsKey === "Shots" ? "highlight gold-gradient-text" : ""}>S</th>
                                        <th>SOT</th>
                                        <th className={ contest.StatsKey === "ShotsOnTarget" ? "highlight gold-gradient-text" : ""}>SOG</th>
                                        <th>CR</th>
                                        <th>FS</th>
                                        <th className={ contest.StatsKey === "FoulsCommit" ? "highlight gold-gradient-text" : ""}>FC</th>
                                        <th className={ contest.StatsKey === "Tackles" ? "highlight gold-gradient-text" : ""}>TKW</th>
                                        <th>INT</th>
                                        <th>Y</th>
                                        <th>R</th>
                                        <th>CS</th>
                                        <th className={ contest.StatsKey === "TCP" ? "highlight gold-gradient-text" : ""}>P</th>
                                        <th className={ contest.StatsKey === "Saves" ? "highlight gold-gradient-text" : ""}>SV</th>
                                        <th className={ contest.StatsKey === "GoalsAllowed" ? "highlight gold-gradient-text" : ""}>GC</th>
                                        <th>DR</th>
                                        <th>CL</th>
                                        <th>CC</th>
                                        <th>BLK</th>
                                    </React.Fragment>
                                }</tr>
                                </thead>
                                {gameStats?.filter((gameStats) => !gameStats.IsPitcher)
                                    .sort((a, b) => moment(a.DateTime).isBefore(moment(b.DateTime)) ? 1 : -1)
                                    .map((gameStats) => {

                                        let gs = gameStats;
                                        if (!gs)
                                            return null;

                                        return <tbody key={gs.GameId}>
                                        <tr>
                                            {
                                                <React.Fragment>
                                                    <td><span
                                                        className="date">{moment(gameStats.DateTime).format("MM/DD")}</span>
                                                        <span
                                                            className="vs"> vs {getTeamShortName(gameStats.Opponent, "SOCCERPlayer")} </span>
                                                    </td>
                                                    <td className={ contest.StatsKey === "Goals" || contest.StatsKey === "GoalsAndAssists" ? "highlight gold-gradient-text" : ""}>{gs.Goal}</td>
                                                    <td className={ contest.StatsKey === "Assists" || contest.StatsKey === "GoalsAndAssists" ? "highlight gold-gradient-text" : ""}>{gs.Assist}</td>
                                                    <td className={ contest.StatsKey === "Shots" ? "highlight gold-gradient-text" : ""}>{gs.Shots}</td>
                                                    <td>{gs.ShotOffTarget}</td>
                                                    <td className={ contest.StatsKey === "ShotsOnTarget" ? "highlight gold-gradient-text" : ""}>{gs.ShotOnGoal}</td>
                                                    <td>{gs.Cross}</td>
                                                    <td>{gs.FoulDrawn}</td>
                                                    <td className={ contest.StatsKey === "FoulsCommit" ? "highlight gold-gradient-text" : ""}>{gs.FoulConceded}</td>
                                                    <td className={ contest.StatsKey === "Tackles" ? "highlight gold-gradient-text" : ""}>{gs.TackleWon}</td>
                                                    <td>{gs.Interception}</td>
                                                    <td>{gs.YellowCard}</td>
                                                    <td>{gs.RedCard}</td>
                                                    <td>{gs.CleanSheet}</td>
                                                    <td className={ contest.StatsKey === "TCP" ? "highlight gold-gradient-text" : ""}>{gs.AccuratePass}</td>
                                                    <td className={ contest.StatsKey === "Saves" ? "highlight gold-gradient-text" : ""}>{gs.Save}</td>
                                                    <td className={ contest.StatsKey === "GoalsAllowed" ? "highlight gold-gradient-text" : ""}>{gs.GoalAllowed}</td>
                                                    <td>{gs.Dribbles}</td>
                                                    <td>{gs.Clearances}</td>
                                                    <td>{gs.ChancesCreated}</td>
                                                    <td>{gs.BlockedShots}</td>
                                                </React.Fragment>
                                            }
                                        </tr>
                                        </tbody>
                                    })}
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        </div>
    </>
};

export default SOCCERGamesStats;